module.exports = __webpack_public_path__ + "static/frontUserNew/img/typeaudio.ba132480.svg";